import { IconType } from 'components/Icon';
import ActionButton from 'components/Widget/ActionButton';
import { downloadDsBundle, tokensToJson } from 'designSystem/content/util';
import { shallowEqual, useSelector } from 'react-redux';
import { selectActiveDesignSystem } from 'redux/db/reducers';
import { RootReducer } from 'redux/reducers';
import { downloadBlob } from 'utils';

interface Props {
	format: 'bundle' | 'tokens-json';
	label?: string;
}

const DownloadDsAction = ({ format, label }: Props) => {
	const { designSystem, designSystemContent } = useSelector(
		(r: RootReducer) => ({
			designSystem: selectActiveDesignSystem(r.db, r.mode.activeDesignSystemId),
			designSystemContent: r.mode.designSystemContent,
		}),
		shallowEqual
	);

	const onClick = async () => {
		if (!designSystem) return;
		if (format === 'tokens-json' && designSystemContent) {
			const tokens = tokensToJson(designSystemContent);
			const json = JSON.stringify(tokens, null, 2);
			const blob = new Blob([json], { type: 'application/json' });
			const name =
				designSystem.title
					?.trim()
					.replace(/[^a-z0-9]/gi, '-')
					.toLowerCase() || 'design-system';
			downloadBlob(blob, `${name}-tokens.json`);
			return;
		}
		const files = designSystemContent?.files;
		if (files && files.length > 0) {
			await downloadDsBundle(files, designSystem.title);
		}
	};

	const resolvedLabel =
		label ?? (format === 'tokens-json' ? 'Download tokens as JSON' : 'Download design system');

	return (
		<ActionButton icon={IconType.LINE_ARROW_DOWN} label={resolvedLabel} onClick={onClick} />
	);
};

export default DownloadDsAction;
